import './App.css';
import ContractGen from './ContractGen';

function App() {
  return (
    <div className="App">
    <ContractGen/>
    </div>
  );
}

export default App;
